module.exports = __webpack_public_path__ + "img/shop-by-minivan.0f04dfaf.png";